import {Model} from "ords/dist/model/model";

export class SubAssignment extends Model {

    hasDeadline() {
        return !!this.deadlines.length;
    }

    getDeadline() { // todo should be changed to single relation
        if (!this.hasDeadline()) {
            return null
        }
        return this.deadlines[0];
    }

    hasStatus() {
        return !!this.statuses.length;
    }

    getStatus() {
        if (!this.hasStatus()) {
            return null
        }
        return this.statuses[0];
    }

    hasPartWithTypeAssignment() {
        for (const page of this.pages) {
            for (const part of page.parts) {
                if (part.isAssignment()) {
                    return true;
                }
            }
        }
        return false;
    }

    hasAssignmentCooperation() {
        return !!this.assignment_cooperations.length
    }

    getAssignmentCooperation() {
        return this.hasAssignmentCooperation
            ? this.assignment_cooperations[0]
            : [];
    }

    hasConfirmedPartnerUser(user_id) {
        return this.assignment_cooperations.some((assignmentCooperation) => {
            return assignmentCooperation.assignment_partners.some((assignmentPartner) => {
                return assignmentPartner.assignment_partner_users.some((assignmentPartnerUser) => {
                    return assignmentPartnerUser.user_id === user_id && assignmentPartnerUser.confirmed;
                })
            })
        })
    }

    hasAssignmentPartnerForUser(user_id) {
        return this.assignment_cooperations.some((assignmentCooperation) => {
            return assignmentCooperation.assignment_partners.some((assignmentPartner) => {
                return assignmentPartner.assignment_partner_users.some((assignmentPartnerUser) => {
                    return assignmentPartnerUser.user_id === user_id;
                })
            })
        })
    }

    getAssignmentPartnerForUser(user_id) {
        const assignmentCooperation = this.getAssignmentCooperation()
        if (assignmentCooperation && Object.keys(assignmentCooperation).length > 0) {
            return assignmentCooperation.assignment_partners.find((assignmentPartner) => {
                return assignmentPartner.assignment_partner_users.some((assignmentPartnerUser) => {
                    return assignmentPartnerUser.user_id === user_id;
                })
            })
        }
        return null;
    }

    // this should be on assignment partner
    getAssignmentPartnerUserForUser(user_id) {
        for (const assignmentPartner of this.getAssignmentCooperation().assignment_partners) {
            for (const assignmentPartnerUser of assignmentPartner.assignment_partner_users) {
                if (assignmentPartnerUser.user_id === user_id) {
                    return assignmentPartnerUser;
                }
            }
        }
        return null;
    }

    hasFeedback() {
        return !!this.feedback.length;
    }

    onlyExplanation() {
        let allExplanation = true;

        for (let page of this.pages) {
            for (let part of page.parts) {
                if (part.isAssignment()) {
                    allExplanation = false;
                }
            }
        }

        return allExplanation;
    }
}

export const SubAssignmentModelConfig = {
    name: 'subAssignment',
    model: SubAssignment,
    relations: [
        {name: 'deadlines', model_name: 'subAssignmentDeadline', returns_many: true, type: 'hasMany'},
        {name: 'pages', model_name: 'assignmentPage', returns_many: true, type: 'hasMany'},
        {name: 'portfolio_rating', model_name: 'portfolioRating', returns_many: false, type: 'hasOne'},
        {name: 'statuses', model_name: 'subAssignmentStatus', returns_many: true, type: 'hasMany'},
        // {name: 'assignment', model_name: 'assignment', returns_many: false, type: 'hasOne'}, todo gives error
        {name: 'feedback', model_name: 'subAssignmentFeedback', returns_many: false, type: 'hasMany'},
        {name: 'assignment_cooperations', model_name: 'assignmentCooperation', type: 'hasMany'},
    ]
}
